const APP_ENV = process.env.NEXT_PUBLIC_APP_ENV || process.env.REACT_APP_ENV;

export const BASE_URI = {
  development: "http://api.localhost:3000",
  staging: "https://api-staging.approveshield.com",
  production: "https://api.approveshield.com",
};

export const HOST_URI = BASE_URI[APP_ENV]

export const LOGIN_URI = "/auth/sign_in";
export const LOGOUT_URI = "/auth/sign_out";
export const VALIDATE_TOKEN_URI = "/auth/validate_token";
export const USERS_URI = "/v1/users";
export const COMMUNITIES_URI = "/v1/communities";
export const RENTAL_APPS_URI = "/v1/rental_applications";
export const ARCHIVED_RENTAL_APPS_URI = "/v1/rental_applications/archived";
export const ANALYSTS_STATS_URI = "/v1/analyst_stats";
